import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { injectJwtTokenIntoHeaders } from 'services/tokenLocalStorage';
import { components } from './types';

type API = components['schemas'];

enum Endpoints {
  VCC_TRANSACTIONS = 'v1/vccs/transactions',
}

class SupplierServiceApi<T extends AxiosWrapper<AxiosInstance>> {
  client: T;

  constructor(client: T) {
    this.client = client;
  }

  vccTransactionsCSV = async (payload: API['VccTransactionsCsvRQ']): Promise<AxiosResponse<Blob>> => {
    const endpoint = `${Endpoints.VCC_TRANSACTIONS}/csv`;
    return this.client.post(endpoint, payload, { responseType: 'blob' });
  };
}

export const makeSupplierServiceApi = (): SupplierServiceApi<AxiosWrapper<AxiosInstance>> => {
  const dynamicParameters = ParameterService.getParameters();
  const headers: any = {};

  const client = axios.create({
    baseURL: dynamicParameters.SUPPLIER_SERVICE_BASE_URL,
    headers: injectJwtTokenIntoHeaders(headers),
    withCredentials: true,
  });

  const clientWrapper = new AxiosWrapper(client);
  return new SupplierServiceApi<AxiosWrapper<AxiosInstance>>(clientWrapper);
};
